import { render, staticRenderFns } from "./AdministrationPage.vue?vue&type=template&id=3d9fb72a&scoped=true"
import script from "./AdministrationPage.vue?vue&type=script&lang=js"
export * from "./AdministrationPage.vue?vue&type=script&lang=js"
import style0 from "./AdministrationPage.vue?vue&type=style&index=0&id=3d9fb72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9fb72a",
  null
  
)

export default component.exports